import { UIEvent } from 'react';

import { Button, ButtonProps } from '@cast/design-system';

import { useSimulatedClusterDemoUi } from '@cast/infrastructure-demo';

import { useCreateEdgeLocationDrawer } from '../hooks/useCreateEdgeLocationDrawer';

type ReviewInstallationScriptButtonProps = ButtonProps & {
  clusterId: string;
  edgeLocationId: string;
  text?: string;
  hideSuccessNotification?: boolean;
};

export const ReviewInstallationScriptButton = ({
  clusterId,
  edgeLocationId,
  text = 'Review installation script',
  hideSuccessNotification,
  ...buttonProps
}: ReviewInstallationScriptButtonProps) => {
  const { openCreateEdgeLocationDrawer } = useCreateEdgeLocationDrawer();
  const isSimulatedClusterDemoUi = useSimulatedClusterDemoUi();

  return (
    <Button
      {...buttonProps}
      testId="review-installation-script-button"
      disabled={isSimulatedClusterDemoUi}
      onClick={(e: UIEvent) => {
        e.stopPropagation();
        openCreateEdgeLocationDrawer({
          clusterId,
          edgeLocationId,
          hideSuccessNotification,
        });
      }}
    >
      {text}
    </Button>
  );
};
